import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useTrainingProgramEligibility,
  useUpdate: useTrainingProgramEligibilityUpdate,
  useDelete: useTrainingProgramEligibilityDeletion,
} = getCRUDHooks({
  entityName: 'trainingProgramEligibility',
  get: ({ trainingProgramId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.trainingPrograms.id(trainingProgramId)
      .eligibility.get(''),
  update: (values, { trainingProgramId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.trainingPrograms.id(trainingProgramId)
      .eligibility.update('', values),
  remove: ({ trainingProgramId }) =>
    clientApi
      .getOCClient()
      .helpers.learningContent.trainingPrograms.id(trainingProgramId)
      .eligibility.delete(''),
});

export {
  useTrainingProgramEligibility,
  useTrainingProgramEligibilityUpdate,
  useTrainingProgramEligibilityDeletion,
};
